/* EarProfit compatibility data
 * Source updated: 2026\u5e745\u670820\u65e5
 * Generated: 2026-08-08
 */
window.EarProfitCompatibilityData = [
  {
    "id": 1,
    "brand": "ABKONCORE",
    "model": "B851",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 5,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 2,
    "brand": "ADV.",
    "model": "Nsmo(2nd Gen)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/adv",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/adv",
    "sourceRow": 7,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 3,
    "brand": "ADV.",
    "model": "Nsmo",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/adv",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/adv",
    "sourceRow": 8,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 4,
    "brand": "ADV.",
    "model": "Alpha",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/adv",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/adv",
    "sourceRow": 9,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 5,
    "brand": "ADV.",
    "model": "R32",
    "aliases": [],
    "status": "\u8907\u6570\u30b5\u30a4\u30ba",
    "sizes": [
      "XM60",
      "XM70"
    ],
    "sizeLabel": "XM60\u25ef/XM70\u25ef",
    "note": "\u8907\u6570\u30b5\u30a4\u30ba\u306b\u9069\u5408\u3057\u307e\u3059\u3002\u5143\u8868\u306e\u8868\u793a\u3092\u3054\u78ba\u8a8d\u304f\u3060\u3055\u3044\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 10,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 6,
    "brand": "ag",
    "model": "AG-WHP01",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 12,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 7,
    "brand": "ag",
    "model": "AG-WHP01K",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 13,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 8,
    "brand": "ag",
    "model": "AG-WHP02",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 14,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 9,
    "brand": "AKG",
    "model": "K240 MKII-Y3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/akg",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/akg",
    "sourceRow": 16,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 10,
    "brand": "AKG",
    "model": "K271  MKII-Y3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/akg",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/akg",
    "sourceRow": 17,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 11,
    "brand": "AKG",
    "model": "K275-Y3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/akg",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/akg",
    "sourceRow": 18,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 12,
    "brand": "AKG",
    "model": "K371-BT-Y3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/akg",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/akg",
    "sourceRow": 19,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 13,
    "brand": "AKG",
    "model": "K550",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 20,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 14,
    "brand": "AKG",
    "model": "K553MKII-Y3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/akg",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/akg",
    "sourceRow": 21,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 15,
    "brand": "AKG",
    "model": "N700NCM2BT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 22,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 16,
    "brand": "AKG",
    "model": "HD490 PRO Plus",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 23,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 17,
    "brand": "AKG",
    "model": "N9\u3000Hybrid",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(AKG_N9_HYBRID)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08AKG_N9_HYBRID\uff09",
    "dedicatedCode": "AKG_N9_HYBRID",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 24,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 18,
    "brand": "AKG",
    "model": "N60 NCBT AKGN60NCBT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 25,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 19,
    "brand": "AKG",
    "model": "Y500 WIRELESS",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 26,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 20,
    "brand": "AKG",
    "model": "Y600NCBT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 27,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 21,
    "brand": "AKG",
    "model": "K812/K872",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(AKG-K812/K872)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08AKG-K812/K872\uff09",
    "dedicatedCode": "AKG-K812/K872",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 28,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 22,
    "brand": "AKG",
    "model": "K612  PRO-Y3",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(AKG_K612 PRO-Y3)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08AKG_K612 PRO-Y3\uff09",
    "dedicatedCode": "AKG_K612 PRO-Y3",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 29,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 23,
    "brand": "AKG",
    "model": "K701-Y3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 30,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 24,
    "brand": "AKG",
    "model": "K702-Y3",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(AKG_K702,K712 PRO-Y3)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08AKG_K702,K712 PRO-Y3\uff09",
    "dedicatedCode": "AKG_K702,K712 PRO-Y3",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 31,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 25,
    "brand": "AKG",
    "model": "K712 PRO-Y3",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(AKG_K702,K712 PRO-Y3)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08AKG_K702,K712 PRO-Y3\uff09",
    "dedicatedCode": "AKG_K702,K712 PRO-Y3",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 32,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 26,
    "brand": "ANIMA",
    "model": "ANW03 Midnight Grand Orchestra Ver.\uff08ANW03-MGO\uff09",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 34,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 27,
    "brand": "ANIMA",
    "model": "ANW03 Brown",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 35,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 28,
    "brand": "Anker",
    "model": "Soundcore Life Q20i",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 39,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 29,
    "brand": "Anker",
    "model": "Soundcore Life Q35",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 40,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 30,
    "brand": "Anker",
    "model": "Soundcore Space Q45",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 41,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 31,
    "brand": "Anker",
    "model": "Soundcore Space One",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 42,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 32,
    "brand": "Anker",
    "model": "Soundcore Space One Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 43,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 33,
    "brand": "APPLE",
    "model": "AirPods Max",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(Apple-AirPods-Max)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08Apple-AirPods-Max\uff09",
    "dedicatedCode": "Apple-AirPods-Max",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 45,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 34,
    "brand": "ASHIDAVOX",
    "model": "ST-31-02",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 47,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 35,
    "brand": "ASHIDAVOX",
    "model": "HA-SX12/HD-W",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 48,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 36,
    "brand": "Astell\uff06Kern \u2715 beyerdynamic",
    "model": "AK T5p 2nd Gen",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 50,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 37,
    "brand": "AUDEZE",
    "model": "Maxwell For PS",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 52,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 38,
    "brand": "AudioTechnica",
    "model": "ATH-R30x",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 54,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 39,
    "brand": "AudioTechnica",
    "model": "ATH-R50x",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 55,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 40,
    "brand": "AudioTechnica",
    "model": "ATH-R70xa",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 56,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 41,
    "brand": "AudioTechnica",
    "model": "ATH-770XCOM",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 57,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 42,
    "brand": "AudioTechnica",
    "model": "ATH-A1000Z",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 58,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 43,
    "brand": "AudioTechnica",
    "model": "ATH-A2000Z",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 59,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 44,
    "brand": "AudioTechnica",
    "model": "ATH-A500Z",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 60,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 45,
    "brand": "AudioTechnica",
    "model": "ATH-A900Z",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 61,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 46,
    "brand": "AudioTechnica",
    "model": "ATH-AD2000X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 62,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 47,
    "brand": "AudioTechnica",
    "model": "ATH-AD500X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 63,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 48,
    "brand": "AudioTechnica",
    "model": "ATH-ADX5000",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 64,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 49,
    "brand": "AudioTechnica",
    "model": "ATH-AD900X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 65,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 50,
    "brand": "AudioTechnica",
    "model": "ATH-ANC90CBT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 66,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 51,
    "brand": "AudioTechnica",
    "model": "ATH-AP2000Ti",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 67,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 52,
    "brand": "AudioTechnica",
    "model": "ATH-AVA300",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 68,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 53,
    "brand": "AudioTechnica",
    "model": "ATH-AVA500",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 69,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 54,
    "brand": "AudioTechnica",
    "model": "ATH-AVC200",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 70,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 55,
    "brand": "AudioTechnica",
    "model": "ATH-AVC500",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 71,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 56,
    "brand": "AudioTechnica",
    "model": "ATH-G1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 72,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 57,
    "brand": "AudioTechnica",
    "model": "ATH-G1WL",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 73,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 58,
    "brand": "AudioTechnica",
    "model": "ATH-GDL3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 74,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 59,
    "brand": "AudioTechnica",
    "model": "ATH-GL3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 75,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 60,
    "brand": "AudioTechnica",
    "model": "ATH-HL7BT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 76,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 61,
    "brand": "AudioTechnica",
    "model": "ATH-M20X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 77,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 62,
    "brand": "AudioTechnica",
    "model": "ATH-M20XBT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 78,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 63,
    "brand": "AudioTechnica",
    "model": "ATH-M30X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 79,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 64,
    "brand": "AudioTechnica",
    "model": "ATH-M40X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 80,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 65,
    "brand": "AudioTechnica",
    "model": "ATH-M50X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 81,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 66,
    "brand": "AudioTechnica",
    "model": "ATH-M50XBT2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 82,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 67,
    "brand": "AudioTechnica",
    "model": "ATH-M60xa",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 83,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 68,
    "brand": "AudioTechnica",
    "model": "ATH-M70X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 84,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 69,
    "brand": "AudioTechnica",
    "model": "ATH-MSR7b GM",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 85,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 70,
    "brand": "AudioTechnica",
    "model": "ATH-PDG1a",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 86,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 71,
    "brand": "AudioTechnica",
    "model": "ATH-PRO5X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 87,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 72,
    "brand": "AudioTechnica",
    "model": "ATH-R70X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 88,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 73,
    "brand": "AudioTechnica",
    "model": "ATH-SR30BT BK",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 89,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 74,
    "brand": "AudioTechnica",
    "model": "ATH-SR50",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 90,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 75,
    "brand": "AudioTechnica",
    "model": "ATH-SR9",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 91,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 76,
    "brand": "AudioTechnica",
    "model": "ATH-SX1a",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 92,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 77,
    "brand": "AudioTechnica",
    "model": "ATH-WP900",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 93,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 78,
    "brand": "AudioTechnica",
    "model": "ATH-WS1100",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 94,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 79,
    "brand": "AudioTechnica",
    "model": "ATH-WS990BT-BRD",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 95,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 80,
    "brand": "AudioTechnica",
    "model": "ATH-WS770",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 96,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 81,
    "brand": "AudioTechnica",
    "model": "ATH-WS550 BSD",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/audiotechnica",
    "sourceRow": 97,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 82,
    "brand": "AudioTechnica",
    "model": "ATH-S500",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 98,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 83,
    "brand": "AudioTechnica",
    "model": "ATH-S100BPK",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 99,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 84,
    "brand": "AudioTechnica",
    "model": "ATH-EP300",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 100,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 85,
    "brand": "AudioTechnica",
    "model": "ATH-AR1 WH",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 101,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 86,
    "brand": "AudioTechnica",
    "model": "ATH-AR3 BL",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 102,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 87,
    "brand": "AudioTechnica",
    "model": "ATH-M60X",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 103,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 88,
    "brand": "AudioTechnica",
    "model": "ATH-WS220BT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 104,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 89,
    "brand": "AudioTechnica",
    "model": "ATH-S200BT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 105,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 90,
    "brand": "AudioTechnica",
    "model": "ATH-ES750",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 106,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 91,
    "brand": "AudioTechnica",
    "model": "ATH-M60X",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 107,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 92,
    "brand": "aune audio",
    "model": "AR5000",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 109,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 93,
    "brand": "aune audio",
    "model": "AR7000",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 110,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 94,
    "brand": "Ausounds",
    "model": "AU-XT ANC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/ausounds",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/ausounds",
    "sourceRow": 112,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 95,
    "brand": "AustrianAudio",
    "model": "The Arranger",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 114,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 96,
    "brand": "AustrianAudio",
    "model": "PG16",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 115,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 97,
    "brand": "AustrianAudio",
    "model": "Hi-X15",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 116,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 98,
    "brand": "AustrianAudio",
    "model": "Hi-X20",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 117,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 99,
    "brand": "AustrianAudio",
    "model": "Hi-X25",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 118,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 100,
    "brand": "AustrianAudio",
    "model": "Hi-X65",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 119,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 101,
    "brand": "AustrianAudio",
    "model": "Hi-X60",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 120,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 102,
    "brand": "AustrianAudio",
    "model": "Hi-X50",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 121,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 103,
    "brand": "AustrianAudio",
    "model": "Hi-X55",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 122,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 104,
    "brand": "AVIOT",
    "model": "WA-Z1PNK(\u30d4\u30a8\u30fc\u30eb\u4e2d\u91ce)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 124,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 105,
    "brand": "AVIOT",
    "model": "WA-V1-PNK(\u30d4\u30a8\u30fc\u30eb\u4e2d\u91ce)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 125,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 106,
    "brand": "BANG & OLUFSEN",
    "model": "Beoplay H4 2nd Gen",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 127,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 107,
    "brand": "BANG & OLUFSEN",
    "model": "Beoplay HX Black",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 128,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 108,
    "brand": "BANG & OLUFSEN",
    "model": "BeoPlay H7",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 129,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 109,
    "brand": "bayerdynamic",
    "model": "Aventho 200",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 131,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 110,
    "brand": "bayerdynamic",
    "model": "AVENTHO 300",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 132,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 111,
    "brand": "bayerdynamic",
    "model": "DJ 300 PRO X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 133,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 112,
    "brand": "bayerdynamic",
    "model": "DT 270 PRO",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 134,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 113,
    "brand": "bayerdynamic",
    "model": "DT 770 PRO X 48\u03a9",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 135,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 114,
    "brand": "bayerdynamic",
    "model": "MMX 300 PRO",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 136,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 115,
    "brand": "bayerdynamic",
    "model": "DT 700 Pro X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 137,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 116,
    "brand": "bayerdynamic",
    "model": "DT 770M",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 138,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 117,
    "brand": "bayerdynamic",
    "model": "DT 770 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 139,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 118,
    "brand": "bayerdynamic",
    "model": "DT 770 Pro Limited Edition",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 140,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 119,
    "brand": "bayerdynamic",
    "model": "DT 1770 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 141,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 120,
    "brand": "bayerdynamic",
    "model": "DT 1770 PRO MK II",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 142,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 121,
    "brand": "bayerdynamic",
    "model": "DT 880 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 143,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 122,
    "brand": "bayerdynamic",
    "model": "DT 900 Pro X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 144,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 123,
    "brand": "bayerdynamic",
    "model": "DT 990 Edition",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 145,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 124,
    "brand": "bayerdynamic",
    "model": "DT 990 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 146,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 125,
    "brand": "bayerdynamic",
    "model": "DT 1990 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 147,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 126,
    "brand": "bayerdynamic",
    "model": "DT 1990 PRO MK II",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 148,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 127,
    "brand": "bayerdynamic",
    "model": "T1 3rd generation",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 149,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 128,
    "brand": "bayerdynamic",
    "model": "T5 3rd generation",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 150,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 129,
    "brand": "bayerdynamic",
    "model": "Amiron Home",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 151,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 130,
    "brand": "bayerdynamic",
    "model": "Amiron Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 152,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 131,
    "brand": "bayerdynamic",
    "model": "Amiron Wireless Copper",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 153,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 132,
    "brand": "bayerdynamic",
    "model": "MMX100",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 154,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 133,
    "brand": "bayerdynamic",
    "model": "MMX 150 (32 Ohm)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 155,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 134,
    "brand": "bayerdynamic",
    "model": "MMX 200",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 156,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 135,
    "brand": "bayerdynamic",
    "model": "MMX300 2nd Gen",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 157,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 136,
    "brand": "Beats by Dr Dre",
    "model": "BT OV STUDIO WIRELS",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 159,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 137,
    "brand": "Beats by Dr Dre",
    "model": "BT OV STUDIO V2 TI",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 160,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 138,
    "brand": "Beats by Dr Dre",
    "model": "Solo3 Wireless",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 161,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 139,
    "brand": "Beats by Dr Dre",
    "model": "Studio3 Wireless",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(Beats-Studio3)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08Beats-Studio3\uff09",
    "dedicatedCode": "Beats-Studio3",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 162,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 140,
    "brand": "Beats by Dr Dre",
    "model": "Studio Pro",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(Beats-Studio3)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08Beats-Studio3\uff09",
    "dedicatedCode": "Beats-Studio3",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 163,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 141,
    "brand": "Beats by Dr Dre",
    "model": "Beats EP BLK",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 164,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 142,
    "brand": "Baseus",
    "model": "Inspire XH1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 166,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 143,
    "brand": "BOSE",
    "model": "QuietComfort 35 wireless I",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 169,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 144,
    "brand": "BOSE",
    "model": "QuietComfort 35 wireless II",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 170,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 145,
    "brand": "BOSE",
    "model": "NC Headphones 700",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/news/bose_nch700_fit",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/news/bose_nch700_fit",
    "sourceRow": 171,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 146,
    "brand": "BOSE",
    "model": "QuietComfort 45 Headphone",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 172,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 147,
    "brand": "BOSE",
    "model": "QuietComfort ULTRA",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 173,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 148,
    "brand": "BOSE",
    "model": "QuietComfort ULTRA 2nd Gen",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 174,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 149,
    "brand": "BOSE",
    "model": "QuietComfort",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 175,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 150,
    "brand": "Bowers & Wilkins",
    "model": "PX7/S \u30b7\u30eb\u30d0\u30fc",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/bowers-wilkins",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/bowers-wilkins",
    "sourceRow": 177,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 151,
    "brand": "Bowers & Wilkins",
    "model": "Px8",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 178,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 152,
    "brand": "Bowers & Wilkins",
    "model": "Px8 S2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 179,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 153,
    "brand": "Bowers & Wilkins",
    "model": "Px7 S2/B \u30d6\u30e9\u30c3\u30af",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 180,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 154,
    "brand": "Bowers & Wilkins",
    "model": "Px7 S2E",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 181,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 155,
    "brand": "Bowers & Wilkins",
    "model": "PX7 S3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 182,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 156,
    "brand": "Bowers & Wilkins",
    "model": "P7/B",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 183,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 157,
    "brand": "Campfire Audio",
    "model": "CASCADE  CAM-5003",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/campfireaudio",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/campfireaudio",
    "sourceRow": 185,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 158,
    "brand": "CoolerMaster",
    "model": "MH-752",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/coolermaster",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/coolermaster",
    "sourceRow": 187,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 159,
    "brand": "CORSAIR",
    "model": "HS35",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/corsair",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/corsair",
    "sourceRow": 189,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 160,
    "brand": "CORSAIR",
    "model": "HS60 HAPTIC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/corsair",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/corsair",
    "sourceRow": 190,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 161,
    "brand": "CORSAIR",
    "model": "HS70 BLUETOOTH",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/corsair",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/corsair",
    "sourceRow": 191,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 162,
    "brand": "CORSAIR",
    "model": "VIRTUOSO RGB SE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/corsair",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/corsair",
    "sourceRow": 192,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 163,
    "brand": "CORSAIR",
    "model": "VIRTUOSO RGB XT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 193,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 164,
    "brand": "CORSAIR",
    "model": "VOID RGB ELITE USB]",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 194,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 165,
    "brand": "CORSAIR",
    "model": "VOID WIRELESS v2 Gaming Headset Carbon",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 195,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 166,
    "brand": "CORSAIR",
    "model": "VOID WIRELESS v2 Gaming Headset White",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 196,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 167,
    "brand": "CORSAIR",
    "model": "Virtuoso MAX Wireless",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 197,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 168,
    "brand": "CREATIVE",
    "model": "Sound BlasterX H6",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 199,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 169,
    "brand": "CROSSZONE",
    "model": "CZ-10",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/info/crosszone",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/info/crosszone",
    "sourceRow": 201,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 170,
    "brand": "CROSSZONE",
    "model": "CZ-10 Enhanced",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 202,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 171,
    "brand": "DALI",
    "model": "IO4/CW",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 204,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 172,
    "brand": "DALI",
    "model": "IO6/IB",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 205,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 173,
    "brand": "Defunc",
    "model": "BT Plus",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 207,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 174,
    "brand": "DEKONI AUDIO",
    "model": "DEKONI BLUE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 209,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 175,
    "brand": "DENON",
    "model": "AH-D110-K",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 212,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 176,
    "brand": "DENON",
    "model": "AH-D1200",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 213,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 177,
    "brand": "DENON",
    "model": "AH-D5200",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 214,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 178,
    "brand": "DENON",
    "model": "AH-D7200",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 215,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 179,
    "brand": "DENON",
    "model": "AH-GC25NC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 216,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 180,
    "brand": "DENON",
    "model": "AH-GC30",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 217,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 181,
    "brand": "DoubleZero",
    "model": "00-001W",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 219,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 182,
    "brand": "Dyson",
    "model": "OnTrac",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 221,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 183,
    "brand": "EarFun",
    "model": "WavePro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 224,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 184,
    "brand": "EarFun",
    "model": "Tune Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 225,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 185,
    "brand": "Edifier",
    "model": "WH700NB",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 227,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 186,
    "brand": "Edifier",
    "model": "W820NB Plus",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 228,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 187,
    "brand": "Edifier",
    "model": "WH950NB",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 229,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 188,
    "brand": "Edifier",
    "model": "STAX SPIRIT S3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 230,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 189,
    "brand": "ELECOM",
    "model": "HS-G30-BK",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 232,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 190,
    "brand": "ELECOM",
    "model": "HS-G40-BK",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 233,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 191,
    "brand": "ELECOM",
    "model": "HS-G60-BK",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 234,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 192,
    "brand": "ELECOM",
    "model": "HS-GM20-BK",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 235,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 193,
    "brand": "EPOS JAPAN",
    "model": "EPOS H3 Black",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 237,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 194,
    "brand": "EPOS JAPAN",
    "model": "EPOS H3 White",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 238,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 195,
    "brand": "EPOS JAPAN",
    "model": "GAME-ONE-BLACK",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 239,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 196,
    "brand": "EPOS JAPAN",
    "model": "GAME-ZERO-BLACK",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 240,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 197,
    "brand": "EPOS JAPAN",
    "model": "GSP-300",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 241,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 198,
    "brand": "EPOS JAPAN",
    "model": "GSP-370",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 242,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 199,
    "brand": "EPOS JAPAN",
    "model": "GSP-500",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 243,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 200,
    "brand": "EPOS JAPAN",
    "model": "GSP-600",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 244,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 201,
    "brand": "EPOS JAPAN",
    "model": "GSP-601",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 245,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 202,
    "brand": "EPOS JAPAN",
    "model": "GSP-670",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 246,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 203,
    "brand": "EPOS JAPAN",
    "model": "H3 Hybrid",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 247,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 204,
    "brand": "EPOS JAPAN",
    "model": "EPOS H3PRO Hybrid",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 248,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 205,
    "brand": "EPOS JAPAN",
    "model": "H6 PRO \u958b\u653e\u578b",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 249,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 206,
    "brand": "EPOS JAPAN",
    "model": "H6 PRO \u5bc6\u9589\u578b",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 250,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 207,
    "brand": "ERZETICH",
    "model": "Charybdis",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 252,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 208,
    "brand": "even",
    "model": "H1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 255,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 209,
    "brand": "FiiO",
    "model": "EH13",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 257,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 210,
    "brand": "FiiO",
    "model": "FT1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 258,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 211,
    "brand": "FiiO",
    "model": "FT3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 259,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 212,
    "brand": "FiiO",
    "model": "FT13",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 260,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 213,
    "brand": "FiiO",
    "model": "FT13 Natural",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 261,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 214,
    "brand": "FiiO",
    "model": "JT1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 262,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 215,
    "brand": "FiiO",
    "model": "JT3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 263,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 216,
    "brand": "final",
    "model": "D8000 FI-D8PALS",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 265,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 217,
    "brand": "final",
    "model": "SONOROUS II",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 266,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 218,
    "brand": "final",
    "model": "SONOROUS III",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 267,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 219,
    "brand": "final",
    "model": "UX1000 BUZZ RHYTHM version",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 268,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 220,
    "brand": "final",
    "model": "UX2000",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 269,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 221,
    "brand": "final",
    "model": "UX3000",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 270,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 222,
    "brand": "final",
    "model": "UX3000 SV",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 271,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 223,
    "brand": "FOCAL",
    "model": "Listen Professional",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 273,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 224,
    "brand": "FOCAL",
    "model": "Lensys Professional",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 274,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 225,
    "brand": "FOCAL",
    "model": "CLEAR MG PRO",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(CLEAR MG PRO)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08CLEAR MG PRO\uff09",
    "dedicatedCode": "CLEAR MG PRO",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 275,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 226,
    "brand": "FOCAL",
    "model": "RADIANCE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 276,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 227,
    "brand": "FOSTEX",
    "model": "T60RP",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 278,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 228,
    "brand": "FOSTEX",
    "model": "T50RP MK3G",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 279,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 229,
    "brand": "FOSTEX",
    "model": "T50RP MK4",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 280,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 230,
    "brand": "FOSTEX",
    "model": "T50RPmk4CL",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 281,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 231,
    "brand": "FOSTEX",
    "model": "T60RPmk2CL",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 282,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 232,
    "brand": "FOSTEX",
    "model": "TH610",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 283,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 233,
    "brand": "FOSTEX",
    "model": "TH900mk2",
    "aliases": [],
    "status": "\u6ce8\u610f\u3042\u308a",
    "sizes": [
      "L70",
      "XXL70"
    ],
    "sizeLabel": "L70\u25b3/XXL70\u25cb",
    "note": "L70\u25b3/XXL70\u25cb",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 284,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": true
  },
  {
    "id": 234,
    "brand": "FOSTEX",
    "model": "TH909",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 285,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 235,
    "brand": "FOSTEX",
    "model": "TH1000RPmk2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 286,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 236,
    "brand": "fumo",
    "model": "fumo TRUTH OpenAirGamingHeadset",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 288,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 237,
    "brand": "GRADO",
    "model": "The Hemp Headphone",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 291,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 238,
    "brand": "GRADO",
    "model": "The White Headphone",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u30b9\u30dd\u30f3\u30b8\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u30b9\u30dd\u30f3\u30b8\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 292,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 239,
    "brand": "GRADO",
    "model": "The Hemp Headphone",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 293,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 240,
    "brand": "GRADO",
    "model": "The White Headphone",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u30b9\u30dd\u30f3\u30b8\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u30b9\u30dd\u30f3\u30b8\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 294,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 241,
    "brand": "GRADO",
    "model": "RS2e",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 295,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 242,
    "brand": "GRADO",
    "model": "RS1e",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 296,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 243,
    "brand": "GRADO",
    "model": "RS60x",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 297,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 244,
    "brand": "GRADO",
    "model": "RS80x",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 298,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 245,
    "brand": "GRADO",
    "model": "RS125x",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 299,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 246,
    "brand": "GRADO",
    "model": "RS225x",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 300,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 247,
    "brand": "GRADO",
    "model": "RS325x",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 301,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 248,
    "brand": "GRADO",
    "model": "GW100",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 302,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 249,
    "brand": "HAYLOU",
    "model": "S35 ANC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 304,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 250,
    "brand": "HIFIMAN",
    "model": "ANANDA",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 307,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 251,
    "brand": "HIFIMAN",
    "model": "ANANDA NANO",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 308,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 252,
    "brand": "HIFIMAN",
    "model": "ANANDA UNVEILED",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 309,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 253,
    "brand": "HIFIMAN",
    "model": "Arya Organic",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 310,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 254,
    "brand": "HIFIMAN",
    "model": "Arya WiFi",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 311,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 255,
    "brand": "HIFIMAN",
    "model": "Arya \u5e73\u9762\u78c1\u6c17\u99c6\u52d5\u578b\u30d8\u30c3\u30c9\u30db\u30f3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 312,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 256,
    "brand": "HIFIMAN",
    "model": "AUDIVINA LE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 313,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 257,
    "brand": "HIFIMAN",
    "model": "Audivina \u5bc6\u9589\u578b\u5e73\u9762\u30d8\u30c3\u30c9\u30db\u30f3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 314,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 258,
    "brand": "HIFIMAN",
    "model": "DEVA",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 315,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 259,
    "brand": "HIFIMAN",
    "model": "DEVA Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 316,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 260,
    "brand": "HIFIMAN",
    "model": "Edition XS",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 317,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 261,
    "brand": "HIFIMAN",
    "model": "Edition XV",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 318,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 262,
    "brand": "HIFIMAN",
    "model": "HE1000 V2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 319,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 263,
    "brand": "HIFIMAN",
    "model": "HE1000 WiFi",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 320,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 264,
    "brand": "HIFIMAN",
    "model": "HE1000se",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 321,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 265,
    "brand": "HIFIMAN",
    "model": "HE400se",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 322,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 266,
    "brand": "HIFIMAN",
    "model": "HE600",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 323,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 267,
    "brand": "HIFIMAN",
    "model": "HE6se \u5e73\u9762\u99c6\u52d5\u30d8\u30c3\u30c9\u30db\u30f3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 324,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 268,
    "brand": "HIFIMAN",
    "model": "HE-R9",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 325,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 269,
    "brand": "HIFIMAN",
    "model": "SUNDARA",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 326,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 270,
    "brand": "HIFIMAN",
    "model": "SUNDARA Closed-Back",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 327,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 271,
    "brand": "HIFIMAN",
    "model": "SUSVARA",
    "aliases": [],
    "status": "\u6ce8\u610f\u3042\u308a",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "\u25b3L70",
    "note": "\u25b3L70",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 328,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": true
  },
  {
    "id": 272,
    "brand": "Hi-Unit",
    "model": "\u30d4\u30c3\u30c9\u30db\u30f32(\u30d4\u30a8\u30fc\u30eb\u4e2d\u91ce)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 331,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 273,
    "brand": "HOUSE of Marley",
    "model": "POSITIVE VIBRATION XL",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 333,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 274,
    "brand": "iBasso Audio",
    "model": "SR2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 335,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 275,
    "brand": "iBasso Audio",
    "model": "SR3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 336,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 276,
    "brand": "INNODESIGN",
    "model": "INNOWAVE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 338,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 277,
    "brand": "iSK",
    "model": "HD9999",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 340,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 278,
    "brand": "Jabra",
    "model": "Elite 85h APAC pack",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 342,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 279,
    "brand": "Jabra",
    "model": "Elite 45h",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 343,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 280,
    "brand": "JAM Audio",
    "model": "TRAVEL ANC",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 345,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 281,
    "brand": "JAM Audio",
    "model": "ALREADY THERE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 346,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 282,
    "brand": "JAM Audio",
    "model": "BEEN THERE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 347,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 283,
    "brand": "JAM Audio",
    "model": "OUT THERE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 348,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 284,
    "brand": "JBL",
    "model": "QUANTUM 100",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 350,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 285,
    "brand": "JBL",
    "model": "QUANTUM 350",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 351,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 286,
    "brand": "JBL",
    "model": "QUANTUM 360",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 352,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 287,
    "brand": "JBL",
    "model": "METEOR ONE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 353,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 288,
    "brand": "JBL",
    "model": "TOUR ONE M2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 354,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 289,
    "brand": "JBL",
    "model": "TOUR ONE M3 Smart Tx",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 355,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 290,
    "brand": "JBL",
    "model": "LIVE 770NC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 356,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 291,
    "brand": "JBL",
    "model": "LIVE 780NC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 357,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 292,
    "brand": "JBL",
    "model": "DUET BT JBLDUETBT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 358,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 293,
    "brand": "JBL",
    "model": "E55BT\u30af\u30a4\u30f3\u30b7\u30fc\u30e2\u30c7\u30eb",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 359,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 294,
    "brand": "JBL",
    "model": "QUANTUM 910",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 360,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 295,
    "brand": "JBL",
    "model": "QUANTUM 800",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 361,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 296,
    "brand": "JBL",
    "model": "QUANTUM 400",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 362,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 297,
    "brand": "JBL",
    "model": "QUANTUM ONE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 363,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 298,
    "brand": "JBL",
    "model": "TUNE 510BT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 364,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 299,
    "brand": "JBL",
    "model": "TUNE 770NC",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 365,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 300,
    "brand": "JBL",
    "model": "CLUB 950NC",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 366,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 301,
    "brand": "JBL",
    "model": "CLUB ONE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 367,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 302,
    "brand": "JBL",
    "model": "TOUR ONE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 368,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 303,
    "brand": "JLab",
    "model": "JBuds Open Wireless\nOpen-Ear Headphones",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 370,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 304,
    "brand": "JVC",
    "model": "CLASS-S WOOD 01",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 373,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 305,
    "brand": "JVC",
    "model": "CLASS-S WOOD 02",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 374,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 306,
    "brand": "JVC",
    "model": "GG-01 H",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 375,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 307,
    "brand": "JVC",
    "model": "HA-RZ510",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 376,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 308,
    "brand": "JVC",
    "model": "HA-RZ710",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 377,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 309,
    "brand": "JVC",
    "model": "HA-RZ910",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 378,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 310,
    "brand": "JVC",
    "model": "HA-S200-BR",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 379,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 311,
    "brand": "JVC",
    "model": "HA-S400-W",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 380,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 312,
    "brand": "JVC",
    "model": "HA-S48BT-B",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 381,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 313,
    "brand": "JVC",
    "model": "HA-S88BN \u30d6\u30e9\u30c3\u30af",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 382,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 314,
    "brand": "JVC",
    "model": "HA-SD7-H",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 383,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 315,
    "brand": "JVC",
    "model": "HA-XP50BT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 384,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 316,
    "brand": "KING LUCKY",
    "model": "B900",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 386,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 317,
    "brand": "Kingstone",
    "model": "HyperX Cloud II",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 389,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 318,
    "brand": "Kingstone",
    "model": "HyperX Cloud II\u3000Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 390,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 319,
    "brand": "Kingstone",
    "model": "HyperX Cloud Alha S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 391,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 320,
    "brand": "Kingstone",
    "model": "HyperX HYPER CLOUD JET DUAL WIRELESS",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 392,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 321,
    "brand": "Kingstone",
    "model": "Cloud Alpha S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 393,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 322,
    "brand": "Kingstone",
    "model": "Cloud Core 7.1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 394,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 323,
    "brand": "Kingstone",
    "model": "Cloud Fight HX-HSCF",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 395,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 324,
    "brand": "Kingstone",
    "model": "Cloud Fight S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 396,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 325,
    "brand": "Kingstone",
    "model": "Cloud for PS4",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 397,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 326,
    "brand": "Kingstone",
    "model": "Cloud II Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 398,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 327,
    "brand": "Kingstone",
    "model": "Cloud MIX",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 399,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 328,
    "brand": "Kingstone",
    "model": "Cloud Orbit HX-HSCO",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 400,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 329,
    "brand": "Kingstone",
    "model": "Cloud Orbit S",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 401,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 330,
    "brand": "Kingstone",
    "model": "Cloud Revolver S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 402,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 331,
    "brand": "Kingstone",
    "model": "CloudStingerCore",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 403,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 332,
    "brand": "Kingstone",
    "model": "CloudStingerCoreWL71",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 404,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 333,
    "brand": "Kingstone",
    "model": "CloudStingerCoreWL",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 405,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 334,
    "brand": "Kingstone",
    "model": "CloudStinger for PS4",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 406,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 335,
    "brand": "Kingstone",
    "model": "CloudStinger",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 407,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 336,
    "brand": "Kingstone",
    "model": "CloudStingerS7.1 PC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 408,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 337,
    "brand": "Kingstone",
    "model": "Revolver 7.1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 409,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 338,
    "brand": "Kiwi Ears",
    "model": "ARDOR",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 411,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 339,
    "brand": "Kiwi Ears",
    "model": "Atheia",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 412,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 340,
    "brand": "Kiwi Ears",
    "model": "Division Black",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 413,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 341,
    "brand": "Kiwi Ears",
    "model": "Ellipse",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 414,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 342,
    "brand": "KORG",
    "model": "NC-Q1 WH",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 416,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 343,
    "brand": "LOGICOOL",
    "model": "ASTRO A40",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 418,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 344,
    "brand": "LOGICOOL",
    "model": "G433",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 419,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 345,
    "brand": "LOGICOOL",
    "model": "logicool PRO X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 420,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 346,
    "brand": "MACKIE",
    "model": "MC-50BT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 422,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 347,
    "brand": "MACKIE",
    "model": "MC-60BT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 423,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 348,
    "brand": "MACKIE",
    "model": "MC-100",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 424,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 349,
    "brand": "MACKIE",
    "model": "MC-250",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 425,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 350,
    "brand": "MACKIE",
    "model": "MC-350",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 426,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 351,
    "brand": "MACKIE",
    "model": "MC-450",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 427,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 352,
    "brand": "Marantz",
    "model": "MPH-1 MP-MPH-001",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 429,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 353,
    "brand": "Marshall",
    "model": "MAJOR III Black",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 431,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 354,
    "brand": "Marshall",
    "model": "Major IV Black",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 432,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 355,
    "brand": "Marshall",
    "model": "MID Bluetooth",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 433,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 356,
    "brand": "Marshall",
    "model": "MasterMonitorBLT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 434,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 357,
    "brand": "Marshall",
    "model": "Monitor II ANC Black",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 435,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 358,
    "brand": "Marshall",
    "model": "Monitor III ANC Black",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 436,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 359,
    "brand": "MASTER & DYNAMIC",
    "model": "MH40 Wireless MH40S2",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 438,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 360,
    "brand": "MEE audio",
    "model": "Matrix Cinema ANC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 440,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 361,
    "brand": "MEE audio",
    "model": "Connect T1CMA",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 441,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 362,
    "brand": "Meze Audio",
    "model": "99Neo 99N-BS",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 443,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 363,
    "brand": "Meze Audio",
    "model": "99Classics 99C-WG",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 444,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 364,
    "brand": "Meze Audio",
    "model": "99Classics 99C-WS",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 445,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 365,
    "brand": "Meze Audio",
    "model": "99 CLASSICS 2nd GEN",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 446,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 366,
    "brand": "Meze Audio",
    "model": "105 AER",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 447,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 367,
    "brand": "Meze Audio",
    "model": "105 SILVA",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 448,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 368,
    "brand": "Meze Audio",
    "model": "109 pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 449,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 369,
    "brand": "Meze Audio",
    "model": "Empryrean",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 450,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 370,
    "brand": "\u6c34\u6708\u96e8(MOONDROP)",
    "model": "\u697d\u5712\u2010PARA",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 452,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 371,
    "brand": "\u6c34\u6708\u96e8(MOONDROP)",
    "model": "EDGE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 453,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 372,
    "brand": "\u6c34\u6708\u96e8(MOONDROP)",
    "model": "\u697d\u5712 PARA2",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 454,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 373,
    "brand": "\u6c34\u6708\u96e8(MOONDROP)",
    "model": "SKYLAND",
    "aliases": [],
    "status": "\u6ce8\u610f\u3042\u308a",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "\u25b3L70",
    "note": "\u25b3L70",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 455,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": true
  },
  {
    "id": 374,
    "brand": "MONDO BY DEFUNC",
    "model": "\u30e2\u30f3\u30c9\u30aa\u30fc\u30d0\u30fc\u30a4\u30e4\u30fc\u30c8\u30e9\u30f3\u30b9\u30da\u30a2\u30ec\u30f3\u30c8",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 457,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 375,
    "brand": "moshi",
    "model": "Avanti Burgundy Red",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 459,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 376,
    "brand": "NEUMANN",
    "model": "NDH20",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 461,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 377,
    "brand": "NEUMANN",
    "model": "NDH20",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 462,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 378,
    "brand": "NobleAudio",
    "model": "Fokus Apollo",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 464,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 379,
    "brand": "nwm",
    "model": "\u30ef\u30a4\u30e4\u30ec\u30b9\u30d1\u30fc\u30bd\u30ca\u30eb\u30fb\u30a4\u30e4\u30fc\u30b9\u30d4\u30fc\u30ab\u30fcnwm ONE",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u7279\u6b8a\u30b5\u30a4\u30ba",
    "note": "\u00d7 \u7279\u6b8a\u30b5\u30a4\u30ba",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 467,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 380,
    "brand": "1MORE",
    "model": "SonoFlow Pro HQ51",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 470,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 381,
    "brand": "1MORE",
    "model": "SonoFlow SE HQ31",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 471,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 382,
    "brand": "1MORE",
    "model": "SonoFlow Pro HQ51",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 472,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 383,
    "brand": "Panasonic",
    "model": "RP-HD10-K",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 474,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 384,
    "brand": "Panasonic",
    "model": "RP-HD600N-K",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 475,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 385,
    "brand": "Panasonic",
    "model": "RP-HTX70-K",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 476,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 386,
    "brand": "PHILIPS",
    "model": "SHP9500CY",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 478,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 387,
    "brand": "PHILIPS",
    "model": "TAPH805",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 479,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 388,
    "brand": "PHILIPS",
    "model": "TAH8856",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u7279\u6b8a\u30b5\u30a4\u30ba",
    "note": "\u00d7 \u7279\u6b8a\u30b5\u30a4\u30ba",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 480,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 389,
    "brand": "PHILIPS",
    "model": "Fidelio M2L",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 481,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 390,
    "brand": "PHILIPS",
    "model": "Fidelio NC1",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 482,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 391,
    "brand": "PHILIPS",
    "model": "Fidelio X3",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 483,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 392,
    "brand": "PHILIPS",
    "model": "TAH5255",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 484,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 393,
    "brand": "PHONON",
    "model": "SMB-01L",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 486,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 394,
    "brand": "PHONON",
    "model": "SMB-03",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 487,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 395,
    "brand": "PHONON",
    "model": "SMB-02",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 488,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 396,
    "brand": "PHONON",
    "model": "kurumi",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 489,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 397,
    "brand": "Pioneer",
    "model": "SE-Master1",
    "aliases": [],
    "status": "\u8981\u78ba\u8a8d",
    "sizes": [],
    "sizeLabel": "",
    "note": "\u5143\u8868\u306e\u9069\u5408\u30b5\u30a4\u30ba\u304c\u7a7a\u6b04\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 491,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": true
  },
  {
    "id": 398,
    "brand": "Pioneer",
    "model": "SE-MHR5",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 492,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 399,
    "brand": "Pioneer",
    "model": "SE-MJ771BT",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 493,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 400,
    "brand": "Pioneer",
    "model": "SE-MS9BN",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/news/pioneer-se-ms9bn_fit",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/news/pioneer-se-ms9bn_fit",
    "sourceRow": 494,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 401,
    "brand": "Pioneer",
    "model": "SE-S3BT(H)",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 495,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 402,
    "brand": "Pioneer",
    "model": "SE-S6BN(B)",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 496,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 403,
    "brand": "Pioneer DJ",
    "model": "HDJ-X10-K",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 498,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 404,
    "brand": "Pioneer DJ",
    "model": "HDJ-X10-S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 499,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 405,
    "brand": "Pioneer DJ",
    "model": "HDJ-X5BT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 500,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 406,
    "brand": "Pioneer DJ",
    "model": "HDJ-X5-S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 501,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 407,
    "brand": "Pioneer DJ",
    "model": "HDJ-X5-K",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 502,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 408,
    "brand": "Pioneer DJ",
    "model": "HDJ-X7-K",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 503,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 409,
    "brand": "Pioneer DJ",
    "model": "HRM-7",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 504,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 410,
    "brand": "Pioneer DJ",
    "model": "HDJ-CUE1",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 505,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 411,
    "brand": "Pioneer DJ",
    "model": "HDJ-S7-W",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 506,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 412,
    "brand": "Pioneer DJ",
    "model": "HDJ-CUE1BT-R",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 507,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 413,
    "brand": "Plantronics",
    "model": "BackBeat FIT 6100",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 509,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 414,
    "brand": "Polk Audio",
    "model": "BuckleBlack&Silver",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 511,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 415,
    "brand": "QUAD",
    "model": "ERA-1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 513,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 416,
    "brand": "QYC",
    "model": "H3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 515,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 417,
    "brand": "RAZER",
    "model": "Barracuda X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 517,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 418,
    "brand": "RAZER",
    "model": "Barracuda X Chroma White Editio",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 518,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 419,
    "brand": "RAZER",
    "model": "Barracuda Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 519,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 420,
    "brand": "RAZER",
    "model": "BlackShark V2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 520,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 421,
    "brand": "RAZER",
    "model": "BlackShark V2 Sp-ED",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 521,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 422,
    "brand": "RAZER",
    "model": "BlackShark V2 HyperSp",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 522,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 423,
    "brand": "RAZER",
    "model": "BlackShark V2 X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 523,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 424,
    "brand": "RAZER",
    "model": "BlackSharkV2 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 524,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 425,
    "brand": "RAZER",
    "model": "Kaira X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 525,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 426,
    "brand": "RAZER",
    "model": "Kaira X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 526,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 427,
    "brand": "RAZER",
    "model": "Kraken Black",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 527,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 428,
    "brand": "RAZER",
    "model": "Kraken",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 528,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 429,
    "brand": "RAZER",
    "model": "Kraken BT Kitty Ed",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 529,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 430,
    "brand": "RAZER",
    "model": "Kraken Kitty V2 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 530,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 431,
    "brand": "RAZER",
    "model": "Kraken Kitty V3 X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 531,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 432,
    "brand": "RAZER",
    "model": "Kraken for Console",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 532,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 433,
    "brand": "RAZER",
    "model": "Kraken Mercury White",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 533,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 434,
    "brand": "RAZER",
    "model": "Kraken V3 X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 534,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 435,
    "brand": "RAZER",
    "model": "Kraken V3 HyperSense",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 535,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 436,
    "brand": "RAZER",
    "model": "Kraken V3 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 536,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 437,
    "brand": "RAZER",
    "model": "Kraken V4",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 537,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 438,
    "brand": "RAZER",
    "model": "Kraken V4 X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 538,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 439,
    "brand": "RAZER",
    "model": "Kraken V4 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 539,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 440,
    "brand": "RAZER",
    "model": "Kraken X for Console",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 540,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 441,
    "brand": "RAZER",
    "model": "Kraken X Mercury",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 541,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 442,
    "brand": "RAZER",
    "model": "Kraken X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 542,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 443,
    "brand": "RAZER",
    "model": "Kraken X USB",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 543,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 444,
    "brand": "RAZER",
    "model": "Nari Essential",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 544,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 445,
    "brand": "RAZER",
    "model": "Nari Ultimate",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 545,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 446,
    "brand": "RAZER",
    "model": "ThresherUltimate PS4",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 546,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 447,
    "brand": "RODE Microphones",
    "model": "NTH-100",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 548,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 448,
    "brand": "Roland",
    "model": "RH-200S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 551,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 449,
    "brand": "Roland",
    "model": "RH-300",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 552,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 450,
    "brand": "Roland",
    "model": "RH-A30",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 553,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 451,
    "brand": "SATOLEX",
    "model": "DH297-A1 PLUS",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 555,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 452,
    "brand": "SENDY AUDIO",
    "model": "Apollo",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 557,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 453,
    "brand": "SENNHEISER",
    "model": "GSP 350",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 560,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 454,
    "brand": "SENNHEISER",
    "model": "GSP 550",
    "aliases": [],
    "status": "\u8981\u78ba\u8a8d",
    "sizes": [],
    "sizeLabel": "70",
    "note": "70",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 561,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": true
  },
  {
    "id": 455,
    "brand": "SENNHEISER",
    "model": "HD 25",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 562,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 456,
    "brand": "SENNHEISER",
    "model": "HD 26 PRO",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 563,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 457,
    "brand": "SENNHEISER",
    "model": "HD 280 PRO MK2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 564,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 458,
    "brand": "SENNHEISER",
    "model": "HD 350BT BLACK",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 565,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 459,
    "brand": "SENNHEISER",
    "model": "HD 4.40BT",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 566,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 460,
    "brand": "SENNHEISER",
    "model": "HD 450BT WHITE (ANC)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 567,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 461,
    "brand": "SENNHEISER",
    "model": "HD 560S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 568,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 462,
    "brand": "SENNHEISER",
    "model": "HD 599",
    "aliases": [],
    "status": "\u6ce8\u610f\u3042\u308a",
    "sizes": [
      "XM60",
      "L70"
    ],
    "sizeLabel": "XM60\u25b3/L70\u25ef",
    "note": "XM60\u25b3/L70\u25ef",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 569,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": true
  },
  {
    "id": 463,
    "brand": "SENNHEISER",
    "model": "HD-100",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 570,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 464,
    "brand": "SENNHEISER",
    "model": "HD-300",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 571,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 465,
    "brand": "SENNHEISER",
    "model": "HD-400S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 572,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 466,
    "brand": "SENNHEISER",
    "model": "HD 400U",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 573,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 467,
    "brand": "SENNHEISER",
    "model": "HD-490PRO",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 574,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 468,
    "brand": "SENNHEISER",
    "model": "HD559",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 575,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 469,
    "brand": "SENNHEISER",
    "model": "HD569",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 576,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 470,
    "brand": "SENNHEISER",
    "model": "HD600",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 577,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 471,
    "brand": "SENNHEISER",
    "model": "HD650",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 578,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 472,
    "brand": "SENNHEISER",
    "model": "HD620S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 579,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 473,
    "brand": "SENNHEISER",
    "model": "HD660S",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 580,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 474,
    "brand": "SENNHEISER",
    "model": "HDB 630",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 581,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 475,
    "brand": "SENNHEISER",
    "model": "ACCENTUM Wireless",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 582,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 476,
    "brand": "SENNHEISER",
    "model": "ACCENTUM Plus\u3000Wireless",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 583,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 477,
    "brand": "SENNHEISER",
    "model": "MOMENTUM Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 584,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 478,
    "brand": "SENNHEISER",
    "model": "MOMENTUM 4 Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/news/momentum-4-wireless-fit",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/news/momentum-4-wireless-fit",
    "sourceRow": 585,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 479,
    "brand": "SENNHEISER",
    "model": "PC 350 SE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 586,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 480,
    "brand": "SENNHEISER",
    "model": "PXC 550-II Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 587,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 481,
    "brand": "SENNHEISER",
    "model": "URBANITE XL NATION i",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 588,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 482,
    "brand": "SENNHEISER",
    "model": "RS 275",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 589,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 483,
    "brand": "SHANLING",
    "model": "HW600",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\n(\u8ca9\u58f2\u4e88\u5b9a)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08\u8ca9\u58f2\u4e88\u5b9a\uff09",
    "dedicatedCode": "\u8ca9\u58f2\u4e88\u5b9a",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 591,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 484,
    "brand": "SHIDO",
    "model": "001(AMP\u30bb\u30c3\u30c8)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 593,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 485,
    "brand": "SHURE",
    "model": "AONIC 40 SBH1DYBK1-J",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 599,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 486,
    "brand": "SHURE",
    "model": "AONIC 50 SBH2350",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(SHURE-AONIC50)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08SHURE-AONIC50\uff09",
    "dedicatedCode": "SHURE-AONIC50",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 600,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 487,
    "brand": "SHURE",
    "model": "AONIC 50 GEN2",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(SHURE-AONIC50)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08SHURE-AONIC50\uff09",
    "dedicatedCode": "SHURE-AONIC50",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 601,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 488,
    "brand": "SHURE",
    "model": "SRH1440",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 602,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 489,
    "brand": "SHURE",
    "model": "SRH1540",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 603,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 490,
    "brand": "SHURE",
    "model": "SRH1840",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 604,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 491,
    "brand": "SHURE",
    "model": "SRH1840",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 605,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 492,
    "brand": "SHURE",
    "model": "SRH240A",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 606,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 493,
    "brand": "SHURE",
    "model": "SRH440",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 607,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 494,
    "brand": "SHURE",
    "model": "SRH440A",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 608,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 495,
    "brand": "SHURE",
    "model": "SRH840",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 609,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 496,
    "brand": "SHURE",
    "model": "SRH840A",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 610,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 497,
    "brand": "SHURE",
    "model": "SRH940",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 611,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 498,
    "brand": "SIVGA",
    "model": "Oriole",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 613,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 499,
    "brand": "SIVGA",
    "model": "Luan",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 614,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 500,
    "brand": "SIVGA",
    "model": "SV021",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 615,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 501,
    "brand": "SIVGA",
    "model": "SV023",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 616,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 502,
    "brand": "SIVGA",
    "model": "Anser",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 617,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 503,
    "brand": "SIVGA",
    "model": "P2Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 618,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 504,
    "brand": "SIVGA",
    "model": "PENG\uff08\u9d6c\uff09",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 619,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 505,
    "brand": "Skullcandy",
    "model": "SLYR Black DigiHype",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 622,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 506,
    "brand": "Skullcandy",
    "model": "SLYR ProBLK DigiHype",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 623,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 507,
    "brand": "Skullcandy",
    "model": "SLYR pro Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 624,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 508,
    "brand": "Skullcandy",
    "model": "PLYR Black DigiHype",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 625,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 509,
    "brand": "Skullcandy",
    "model": "CRUSHER 360",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 626,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 510,
    "brand": "Skullcandy",
    "model": "CRUSHER ANC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 627,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 511,
    "brand": "Skullcandy",
    "model": "CRUSHER ANC2 TRUE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 628,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 512,
    "brand": "Skullcandy",
    "model": "CRUSHER ANC MOAB",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 629,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 513,
    "brand": "Skullcandy",
    "model": "CRUSHER EVO",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 630,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 514,
    "brand": "Skullcandy",
    "model": "HESH 540 ANC Wireless Over Ear",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 631,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 515,
    "brand": "Skullcandy",
    "model": "HESH ANC",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 632,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 516,
    "brand": "Skullcandy",
    "model": "Riff Wireless",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 633,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 517,
    "brand": "Skullcandy",
    "model": "S5AVIX-530",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 634,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 518,
    "brand": "Skullcandy",
    "model": "Standout",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 635,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 519,
    "brand": "Skullcandy",
    "model": "VENUE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 636,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 520,
    "brand": "SOL REPUBLIC",
    "model": "TRACKS HD LimEd",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 638,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 521,
    "brand": "SOL REPUBLIC",
    "model": "SOL TRACKS HD2",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 639,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 522,
    "brand": "SOL REPUBLIC",
    "model": "SOL MASTER TRACKS",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 640,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 523,
    "brand": "Sonos",
    "model": "Ace",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 642,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 524,
    "brand": "SONY",
    "model": "CUHJ-15001",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 645,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 525,
    "brand": "SONY",
    "model": "MDR-1000X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 646,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 526,
    "brand": "SONY",
    "model": "MDR-1AM2 BQ",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 647,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 527,
    "brand": "SONY",
    "model": "MDR-1R",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 648,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 528,
    "brand": "SONY",
    "model": "MDR-7506",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 649,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 529,
    "brand": "SONY",
    "model": "MDR-CD900ST",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/news/sony-mdr-cd900st_color",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/news/sony-mdr-cd900st_color",
    "sourceRow": 650,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 530,
    "brand": "SONY",
    "model": "MDR-H600A NC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 651,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 531,
    "brand": "SONY",
    "model": "MDR-HW700DS",
    "aliases": [],
    "status": "\u6ce8\u610f\u3042\u308a",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "\u25b3XM70\u88c5\u7740\u53ef\u80fd\u3067\u3059\u304c\u3001\u7279\u6b8a\u30d1\u30c3\u30c9\u306e\u305f\u3081\u30d1\u30c3\u30c9\u81ea\u4f53\u304c\u5727\u7e2e\u3055\u308c\u307e\u3059\u3002\u751f\u5730\u3082\u5074\u9762\u9014\u4e2d\u307e\u3067\u3057\u304b\u30ab\u30d0\u30fc\u3067\u304d\u307e\u305b\u3093\u3002",
    "note": "\u25b3XM70\u88c5\u7740\u53ef\u80fd\u3067\u3059\u304c\u3001\u7279\u6b8a\u30d1\u30c3\u30c9\u306e\u305f\u3081\u30d1\u30c3\u30c9\u81ea\u4f53\u304c\u5727\u7e2e\u3055\u308c\u307e\u3059\u3002\u751f\u5730\u3082\u5074\u9762\u9014\u4e2d\u307e\u3067\u3057\u304b\u30ab\u30d0\u30fc\u3067\u304d\u307e\u305b\u3093\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 652,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": true
  },
  {
    "id": 532,
    "brand": "SONY",
    "model": "MDR-M1ST",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 653,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 533,
    "brand": "SONY",
    "model": "MDR-M1 Q",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 654,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 534,
    "brand": "SONY",
    "model": "MDR-MV1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 655,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 535,
    "brand": "SONY",
    "model": "MDR-XB950BTB",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 656,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 536,
    "brand": "SONY",
    "model": "MDR-Z1000",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 657,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 537,
    "brand": "SONY",
    "model": "MDR-Z1R",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 658,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 538,
    "brand": "SONY",
    "model": "MDR-Z7M2 Q",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 659,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 539,
    "brand": "SONY",
    "model": "MDR-ZX110B",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 660,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 540,
    "brand": "SONY",
    "model": "MDR-ZX310B",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 661,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 541,
    "brand": "SONY",
    "model": "MDR-ZX770BNL",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 662,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 542,
    "brand": "SONY",
    "model": "PULSE 3D Wireless",
    "aliases": [],
    "status": "\u8907\u6570\u30b5\u30a4\u30ba",
    "sizes": [
      "XM60",
      "XM70"
    ],
    "sizeLabel": "XM60\u25ef/XM70\u25ef",
    "note": "\u8907\u6570\u30b5\u30a4\u30ba\u306b\u9069\u5408\u3057\u307e\u3059\u3002\u5143\u8868\u306e\u8868\u793a\u3092\u3054\u78ba\u8a8d\u304f\u3060\u3055\u3044\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 663,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 543,
    "brand": "SONY",
    "model": "PULSE Elite",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 664,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 544,
    "brand": "SONY",
    "model": "INZONE H3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 665,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 545,
    "brand": "SONY",
    "model": "INZONE H5",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 666,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 546,
    "brand": "SONY",
    "model": "INZONE H7\n\u3010WH-G700\u3011",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 667,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 547,
    "brand": "SONY",
    "model": "INZONE H9",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 668,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 548,
    "brand": "SONY",
    "model": "INZONE H9 II",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 669,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 549,
    "brand": "SONY",
    "model": "WH-1000XM2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 670,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 550,
    "brand": "SONY",
    "model": "WH-1000XM3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/news/sony-wh-1000xm3_fit",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/news/sony-wh-1000xm3_fit",
    "sourceRow": 671,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 551,
    "brand": "SONY",
    "model": "WH-1000XM4",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/news/sony_wh-1000xm4_fit",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/news/sony_wh-1000xm4_fit",
    "sourceRow": 672,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 552,
    "brand": "SONY",
    "model": "WH-1000XM5",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "https://earprofit.com/blogs/news/sony-wh-1000xm5",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/blogs/news/sony-wh-1000xm5",
    "sourceRow": 673,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 553,
    "brand": "SONY",
    "model": "WH-1000XM6",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 674,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 554,
    "brand": "SONY",
    "model": "WH-CH400 BZ",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 675,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 555,
    "brand": "SONY",
    "model": "WH-CH510 BZ",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 676,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 556,
    "brand": "SONY",
    "model": "WH-CH710N BZ \u30d6\u30e9\u30c3\u30af",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 677,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 557,
    "brand": "SONY",
    "model": "WH-CH720N",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 678,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 558,
    "brand": "SONY",
    "model": "WH-H810 B",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 679,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 559,
    "brand": "SONY",
    "model": "WH-H810 G",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 680,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 560,
    "brand": "SONY",
    "model": "WH-H910N L",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 681,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 561,
    "brand": "SONY",
    "model": "WH-ULT900N(ULT WEAR)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 682,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 562,
    "brand": "SONY",
    "model": "WH-XB700",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 683,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 563,
    "brand": "SONY",
    "model": "WH-XB900N BC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 684,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 564,
    "brand": "SONY",
    "model": "WH-XB910N",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 685,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 565,
    "brand": "SOUL",
    "model": "Emotion Max",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 687,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 566,
    "brand": "SOUL",
    "model": "ULTRA WIRELESS2",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 688,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 567,
    "brand": "SOUL",
    "model": "ULTRA WIRELESS ANC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 689,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 568,
    "brand": "SOUNDPEATS",
    "model": "Space",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 691,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 569,
    "brand": "SOUNDWARRIOR",
    "model": "SW-HP100",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u7a74\u304c\u5c0f\u3055\u3044",
    "note": "\u00d7\u7a74\u304c\u5c0f\u3055\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 694,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 570,
    "brand": "SOUNDWARRIOR",
    "model": "SW-HP20-B",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u7a74\u304c\u5c0f\u3055\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u7a74\u304c\u5c0f\u3055\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 695,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 571,
    "brand": "SOUNDWARRIOR",
    "model": "SW-HP300",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u7a74\u304c\u5c0f\u3055\u3044",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u7a74\u304c\u5c0f\u3055\u3044",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 696,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 572,
    "brand": "STATUS",
    "model": "FLAG SHIP ANC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 698,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 573,
    "brand": "STATUS",
    "model": "Core ANC",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 699,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 574,
    "brand": "STAX",
    "model": "SR-X1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 701,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 575,
    "brand": "Steelseries",
    "model": "Artics 1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 704,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 576,
    "brand": "Steelseries",
    "model": "Arctis 1 Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 705,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 577,
    "brand": "Steelseries",
    "model": "Arctis Nova 1",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 706,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 578,
    "brand": "Steelseries",
    "model": "Arctis Nova 1P",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 707,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 579,
    "brand": "Steelseries",
    "model": "Arctis Nova Pro Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 708,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 580,
    "brand": "Steelseries",
    "model": "Arctis Nova Elite Obsidian",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 709,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 581,
    "brand": "Steelseries",
    "model": "Arctis Nova 3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 710,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 582,
    "brand": "Steelseries",
    "model": "Arctis Nova \uff14X",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 711,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 583,
    "brand": "Steelseries",
    "model": "Arctis Nova 7 WL",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 712,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 584,
    "brand": "Steelseries",
    "model": "Arctis Nova 7P WL",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 713,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 585,
    "brand": "Steelseries",
    "model": "Arctis 3 (2019Ed)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 714,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 586,
    "brand": "Steelseries",
    "model": "Artics 5 (2019Ed)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 715,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 587,
    "brand": "Steelseries",
    "model": "Arctis 7 (2019Ed)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 716,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 588,
    "brand": "Steelseries",
    "model": "Arctis 7P",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 717,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 589,
    "brand": "Steelseries",
    "model": "Arctis 9 Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 718,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 590,
    "brand": "Steelseries",
    "model": "Artics Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 719,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 591,
    "brand": "Steelseries",
    "model": "Arctis Pro Wireless",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 720,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 592,
    "brand": "Steelseries",
    "model": "Artics Prime",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 721,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 593,
    "brand": "Sudio",
    "model": "K2 Pro",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 723,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 594,
    "brand": "SVN Sound",
    "model": "by SteveAoki Neon100",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 726,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 595,
    "brand": "TAGO STUDIO",
    "model": "T3-01",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 728,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 596,
    "brand": "TAGO STUDIO",
    "model": "T3-03",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 729,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 597,
    "brand": "TASCAM",
    "model": "TH-06",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 731,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 598,
    "brand": "TASCAM",
    "model": "TH-02",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 732,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 599,
    "brand": "TANCHJIM",
    "model": "RITA",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 734,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 600,
    "brand": "Technics",
    "model": "EAH-DJ1200",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 737,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 601,
    "brand": "THEIAUDIO",
    "model": "Ghost",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 739,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 602,
    "brand": "TOON WORKSHOP",
    "model": "THP-01",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 741,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 603,
    "brand": "TORQUE",
    "model": "t402v",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 743,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 604,
    "brand": "ULTRASONE",
    "model": "ISAR\n\u3010ULT-ISAR\u3011",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 745,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 605,
    "brand": "ULTRASONE",
    "model": "METEOR ONE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 746,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 606,
    "brand": "ULTRASONE",
    "model": "edition5",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 747,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 607,
    "brand": "ULTRASONE",
    "model": "edition15",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 748,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 608,
    "brand": "ULTRASONE",
    "model": "Signature DXP",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 749,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 609,
    "brand": "ULTRASONE",
    "model": "Signature MASTER",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 750,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 610,
    "brand": "ULTRASONE",
    "model": "Signature MASTER MkII",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 751,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 611,
    "brand": "ULTRASONE",
    "model": "Signature PULSE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 752,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 612,
    "brand": "ULTRASONE",
    "model": "Signature PURE",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 753,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 613,
    "brand": "ULTRASONE",
    "model": "Signature STUDIO",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 754,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 614,
    "brand": "ULTRASONE",
    "model": "Signature FUSION",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 755,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 615,
    "brand": "ULTRASONE",
    "model": "Signature FUSION Open Back",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 756,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 616,
    "brand": "ULTRASONE",
    "model": "Tribute 7",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 757,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 617,
    "brand": "UNCOMMON",
    "model": "PHD-1 \u5e73\u9762\u99c6\u52d5\u578b\u30d8\u30c3\u30c9\u30db\u30f3",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 759,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 618,
    "brand": "Urbanista",
    "model": "MIAMI Noise Cancelling Bluetooth",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 761,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 619,
    "brand": "Urbanista",
    "model": "LOS ANGELES Solar Powered ANC",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 762,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 620,
    "brand": "Urbanista",
    "model": "VALENCIA Midnight Black",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 763,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 621,
    "brand": "Victor",
    "model": "HA-MX 100V",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 765,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 622,
    "brand": "Victor",
    "model": "Victor HA-WM90-B",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "L70"
    ],
    "sizeLabel": "L70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 766,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 623,
    "brand": "V-MODA",
    "model": "CROSSFADE 2 WL CODEXED",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(VMODA-CFII)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08VMODA-CFII\uff09",
    "dedicatedCode": "VMODA-CFII",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 768,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 624,
    "brand": "V-MODA",
    "model": "CROSSFADE 3 WL",
    "aliases": [],
    "status": "\u5c02\u7528\u8a2d\u8a08",
    "sizes": [],
    "sizeLabel": "\u2605\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\n(VMODA-CFII)",
    "note": "\u5c02\u7528\u8a2d\u8a08\u30e2\u30c7\u30eb\u3042\u308a\uff08VMODA-CFII\uff09",
    "dedicatedCode": "VMODA-CFII",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 769,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 625,
    "brand": "V-MODA",
    "model": "crossfade lp2",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 770,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 626,
    "brand": "V-MODA",
    "model": "CrossfadeM-100Master",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "M55"
    ],
    "sizeLabel": "M55",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 771,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 627,
    "brand": "V-MODA",
    "model": "M-200 Black  M200-BK",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 772,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 628,
    "brand": "V-MODA",
    "model": "M-200ANC",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 773,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 629,
    "brand": "V-MODA",
    "model": "XS-MatteBlack",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 774,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 630,
    "brand": "VOX",
    "model": "VH-Q1 BK",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 776,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 631,
    "brand": "VOX",
    "model": "VGA-AC30",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 777,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 632,
    "brand": "VOX",
    "model": "VGA-BASS",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 778,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 633,
    "brand": "YAMAHA",
    "model": "HPH-MT5",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 780,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 634,
    "brand": "YAMAHA",
    "model": "HPH-MT7",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 781,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 635,
    "brand": "YAMAHA",
    "model": "HPH-MT8",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 782,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 636,
    "brand": "YAMAHA",
    "model": "HPH-W300",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 783,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 637,
    "brand": "YAMAHA",
    "model": "ONIKUMA M190ProStGm",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XXL70"
    ],
    "sizeLabel": "XXL70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 784,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 638,
    "brand": "YAMAHA",
    "model": "YH-E700B",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "note": "\u00d7\u5165\u3089\u306a\u3044\uff08\u61d0\u306a\u3057\uff09",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 785,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 639,
    "brand": "YAMAHA",
    "model": "YH-L500A(B)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 786,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 640,
    "brand": "YAMAHA",
    "model": "YH-L700A(B)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 787,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 641,
    "brand": "YAMAHA",
    "model": "YH-5000SE(B)",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": 788,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 642,
    "brand": "YAMAHA",
    "model": "UHP-01",
    "aliases": [],
    "status": "\u4e0d\u9069\u5408",
    "sizes": [],
    "sizeLabel": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "note": "\u00d7 \u30aa\u30f3\u30a4\u30e4\u30fc\u30bf\u30a4\u30d7",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "",
    "ctaLabel": "",
    "ctaUrl": "",
    "sourceRow": 789,
    "sourceUrl": "https://earprofit.com/blogs/news/eartouch_%E9%81%A9%E5%90%88%E8%A1%A8",
    "sourceUpdated": "2026\u5e745\u670820\u65e5",
    "reviewRequired": false
  },
  {
    "id": 643,
    "brand": "SENNHEISER",
    "model": "HD 480 PRO",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM70"
    ],
    "sizeLabel": "XM70",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": "\u8ffd\u52a0",
    "sourceUrl": "",
    "sourceUpdated": "2026\u5e748\u67088\u65e5",
    "reviewRequired": false
  },
  {
    "id": 644,
    "brand": "SONY",
    "model": "INZONE H6 Air",
    "aliases": [],
    "status": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f",
    "sizes": [
      "XM60"
    ],
    "sizeLabel": "XM60",
    "note": "\u9069\u5408\u78ba\u8a8d\u6e08\u307f\u3067\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": "\u8ffd\u52a0",
    "sourceUrl": "",
    "sourceUpdated": "2026\u5e748\u67088\u65e5",
    "reviewRequired": false
  },
  {
    "id": 645,
    "brand": "SONY",
    "model": "WH-1000X THE COLLEXION",
    "aliases": [
  "WH1000XX",
  "WH-1000XX"
],
    "status": "\u8907\u6570\u30b5\u30a4\u30ba",
    "sizes": [
      "M55",
      "XM60"
    ],
    "sizeLabel": "M55\u25ef/XM60\u25ef",
    "note": "M55\u3068XM60\u306e\u4e21\u30b5\u30a4\u30ba\u306b\u9069\u5408\u3057\u307e\u3059\u3002",
    "dedicatedCode": "",
    "detailUrl": "",
    "productUrl": "https://earprofit.com/products/earprofit-multi-2",
    "ctaLabel": "EarProfit multi 2\u3092\u898b\u308b",
    "ctaUrl": "https://earprofit.com/products/earprofit-multi-2",
    "sourceRow": "\u8ffd\u52a0",
    "sourceUrl": "",
    "sourceUpdated": "2026\u5e748\u67088\u65e5",
    "reviewRequired": false
  }
];